import { render } from "./AppointementSummaryLg.vue?vue&type=template&id=3749816c"
import script from "./AppointementSummaryLg.vue?vue&type=script&lang=js"
export * from "./AppointementSummaryLg.vue?vue&type=script&lang=js"

import "./AppointementSummaryLg.vue?vue&type=style&index=0&id=3749816c&lang=css"
script.render = render

export default script